import type {BuilderStyle, BuilderTypes, CompRef} from '@wix/document-services-types'
import type {DAL, DalItem} from '@wix/document-manager-core'
import {isNil, noop} from 'lodash'
import type {SchemaAPI} from '../extensions/schema/schema'

type OnError = (message: string, extras: any) => void

function validateLanguageCode(languageCode: string) {
    if (!languageCode) throw new Error('this API requires a language code')
}

function getComp(dal: DAL, compRef: CompRef, onError: OnError = noop): DalItem {
    const comp = dal.get(compRef)
    if (!comp) {
        onError('Component not found', {compRef})
    }
    return comp
}

function builderTypes(schemaAPI: SchemaAPI, compType: string, onError: OnError = noop): BuilderTypes {
    return (
        schemaAPI.getDefinition(compType)?.builderTypes ??
        onError(`No builderTypes for component type ${compType}`, {compType})
    )
}

function autoType<T extends Record<string, any>>(obj: T, expectedType: string, onError: OnError = noop): T {
    if (isNil(obj)) {
        return obj
    }
    const typeWasExplicitlyDeclared = obj.type !== undefined
    if (typeWasExplicitlyDeclared && obj.type !== expectedType) {
        onError('Type mismatch', {expectedType, actualType: obj.type})
    }
    return typeWasExplicitlyDeclared ? obj : {...obj, type: expectedType}
}
const isBuilderStyle = (style: any): style is BuilderStyle => style?.type?.endsWith('.Style')

const isBuilderData = (type: string): boolean => {
    return type.endsWith('.Data')
}

export {getComp, builderTypes, autoType, validateLanguageCode, isBuilderStyle, isBuilderData}
